var map = {
	"./attach.svg": 8912,
	"./back.svg": 9082,
	"./bar-gym.svg": 6700,
	"./change.svg": 6875,
	"./check.svg": 2497,
	"./checklist.svg": 7593,
	"./clock.svg": 2075,
	"./comments.svg": 7089,
	"./document-fit.svg": 1042,
	"./edit.svg": 975,
	"./empty-mailbox.svg": 3945,
	"./history.svg": 3185,
	"./multiple-add-user.svg": 7255,
	"./paid.svg": 5017,
	"./pending.svg": 7352,
	"./person-dumbbell.svg": 810,
	"./person-warning.svg": 3735,
	"./person.svg": 4388,
	"./qr.svg": 6690,
	"./report.svg": 7501,
	"./request-mailbox.svg": 2485,
	"./sync.svg": 8906,
	"./token-fitpal.svg": 3879,
	"./trash.svg": 6891,
	"./user-check.svg": 1273
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6669;